import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import * as actions from '../orderHistoryActions';
import { withStyles } from '@material-ui/core/styles';
import { Headline, Caption1, Title1 } from '../../../components/Typography';
import { PrimaryButton, AddButton } from '../../../components/Buttons';
import { getProductItemCount } from '../utils/displayOptionsItems';
import appConfig from '../../../../app-config';

const styles = () => ({
  paper: {
    margin: 0,
    maxWidth: '600px',
  },
});

const Wrapper = styled.div`
  padding: 12px;
  // width: 600px;

  @media (min-width: 786px) {
    padding: 32px;
    width: 600px;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
`;

const Title = styled(Title1)`
  color: ${(props) => props.theme.black};
  font-weight: 600;
`;

const DateAndAddAll = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  background: ${(props) => props.theme.orderAgainTitleBackgroundColor};
  color: ${(props) => props.theme.orderAgainTitleFontColor};
  border-radius: 8px;
  height: 51px;
  padding: 0 10px;
`;

const Cancel = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: white;
  background-color: ${(props) => props.theme.darkGray};
  right: 8px;
  top: 8px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.closeButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const AddAllButton = styled(PrimaryButton)`
  border: 1px solid ${(props) => props.theme.orderAgainButtonBorderColor};
  height: 36px;
  font-size: 14px;
  box-shadow: none;
  border-radius: ${(props) => props.theme.addAllOrdersButtonRadius};
  background: ${(props) => props.theme.orderAgainTitleButtonBackgroundColor};
  color: ${(props) => props.theme.orderAgainTitleButtonFontColor};
  font-weight: 600;
  text-transform: ${(props) =>
    props.theme.addAllButtonTextTransform
      ? props.theme.addAllButtonTextTransform
      : 'uppercase'};

  &:hover {
    background: ${(props) =>
      props.theme.orderAgainTitleButtonBackgroundColorHover};
    border: 0;
    color: ${(props) =>
      props.theme.orderAgainTitleButtonTextColorHover} !important;
    transition: all 0.25s ease;
  }
`;
const OrderWrapper = styled.div`
  border: 1px solid ${(props) => props.theme.orderAgainBorderColor};
  border-radius: 12px;
`;

const Products = styled.div`
  margin: 10px 0;
`;

const ProductWrapper = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.isNoImage ? null : '70px auto')};
  grid-gap: 8px;
  padding: 10px 15px;
  align-items: center;
  cursor: ${(props) => (props.isAvailable ? 'pointer' : 'default')};

  &:hover {
    background-color: #faf9f9;
    transition: all 0.25s ease;
  }

  @media (max-width: 768px) {
    grid-template-columns: 56px auto;
    grid-gap: 5px;
  }
`;

const ProductImage = styled.img`
  height: 70px;
  width: 70px;
  object-fit: cover;
  border-radius: 50%;
  color: ${(props) => (props.isAvailable ? 'inherit' : props.theme.gray)};
  filter: ${(props) => (props.isAvailable ? null : 'grayscale(0.9)')};
  @media (max-width: 768px) {
    height: 56px;
    width: 56px;
  }
`;

const NonProductImage = styled.div`
  display: grid;
  grid-gap: 19px;

  @media (max-width: 768px) {
    grid-gap: 16px;
  }
`;

const ProductInfoWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 72px;
  grid-gap: 5px;
  align-items: center;

  @media (max-width: 768px) {
    grid-gap: 5px;
  }
`;
const ImageWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  height: 100%;
`;

const ProductInfo = styled.div`
  display: grid;
  grid-gap: 6px;

  @media (max-width: 768px) {
    grid-gap: 2px;
  }
`;
const LocationWrapper = styled.span`
  font-size: 14px;
  font-weight: normal;
`;
const OptionTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
`;
const ItemTitle = styled.div`
  font-size: 12px;
  font-weight: normal;
`;

const ProductName = styled(Headline)`
  color: ${(props) =>
    props.isAvailable
      ? props.theme.black
      : props.theme.unavailableProductColor};
  text-transform: capitalize;
`;

const ProductDescription = styled(Caption1)`
  color: ${(props) =>
    props.isAvailable
      ? props.theme.darkGray
      : props.theme.unavailableProductColor};
  @media (max-width: 768px) {
    // display: none;
  }
`;

const PriceAndAdd = styled.div`
  display: grid;
  grid-gap: 6px;
`;

const CardTitle = styled(Headline)`
  color: ${(props) => props.theme.orderAgainTitleFontColor};
`;

const ProductsHistoryWrappers = ({
  index,
  product,
  foundProduct,
  optionItems,
  addPastOrderToCart,
  setOrderHistoryModalIsVisible,
}) => {
  return (
    <ProductWrapper
      key={index}
      isNoImage={appConfig.isNoImage}
      isAvailable={foundProduct && foundProduct.is_product_available}
      // onClick={() => {
      //   foundProduct &&
      //     foundProduct.is_product_available &&
      //     editPreviousProductConfiguration(
      //       product,
      //       null,
      //       null,
      //       null,
      //       true
      //     );
      // }}
    >
      {!appConfig.isNoImage && (
        <ImageWrapper>
          <ProductImage
            isAvailable={foundProduct && foundProduct.is_product_available}
            src={product.image_url}
          />
        </ImageWrapper>
      )}
      <NonProductImage>
        <ProductInfoWrapper>
          <ProductInfo>
            <ProductName
              id='OrderHistory-ProductName'
              isAvailable={foundProduct && foundProduct.is_product_available}
            >
              {product.name}
              {product.quantity > 1 && ` x${product.quantity}`}
            </ProductName>
            {product.options && (
              <>
                <ProductDescription
                  id='OrderHistory-ProductDescription'
                  isAvailable={
                    foundProduct && foundProduct.is_product_available
                  }
                >
                  <p style={{ fontSize: '14px' }}>{product?.prices[0]?.name}</p>
                </ProductDescription>
              </>
            )}
            {optionItems[index]?.options.map((option, optionIndex) => (
              <Fragment key={`option-items-${optionIndex}`}>
                <OptionTitle>{option.optionName}</OptionTitle>
                {option.items.map((item, itemIndex) => (
                  <ItemTitle key={`items-${itemIndex}`}>- {item}</ItemTitle>
                ))}
              </Fragment>
            ))}
          </ProductInfo>
          <PriceAndAdd>
            {foundProduct && foundProduct.is_product_available ? (
              <AddButton
                id='OrderHistory-AddButton'
                onClick={(e) => {
                  addPastOrderToCart(product, null, true);
                  setOrderHistoryModalIsVisible(false);
                  e.stopPropagation();
                }}
              />
            ) : (
              <div
                style={{
                  color: appConfig.styleConfig.unavailableProductColor,
                }}
              >
                Sold Out
              </div>
            )}
          </PriceAndAdd>
        </ProductInfoWrapper>
      </NonProductImage>
    </ProductWrapper>
  );
};

const mapStateToProps = (state) => ({
  orderHistoryModalIsVisible:
    state.orderHistoryReducer.orderHistoryModalIsVisible,
});

export default withStyles(styles)(
  connect(mapStateToProps, actions)(ProductsHistoryWrappers)
);
